module.exports = __webpack_public_path__ + "static/media/4v.4f56de17.jpg";